import React from 'react';
import cls from 'classnames';
import { Breadcrumbs } from '@/components';
import { RecentActivities } from './recent-activities';
import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { GeneralSettings } from './general-settings';
import { Rewards } from './rewards';
import { EditProfile } from './edit-profile';
import { Connections } from './connections';
import { useTranslation } from 'react-i18next';

export default function SettingsView() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const navigation = [
    {
      text: t('General Settings'),
      to: '/settings',
    },
    /*    {
      text: t('Recent Activities'),
      to: '/settings/activities',
    },*/
    {
      text: t('My Rewards'),
      to: '/settings/rewards',
    },
    {
      text: t('Connections'),
      to: '/settings/connect',
    },
    // {
    //   text: t('Edit Profile'),
    //   to: '/settings/profile',
    // },
    {
      text: t('Change Avatar'),
      to: '/settings/account/avatar',
    },
    {
      text: t('Change Email'),
      to: '/settings/account/email',
    },

    {
      text: t('Change Username'),
      to: '/settings/account/username',
    },
    {
      text: t('Change Password'),
      to: '/settings/account/password',
    },
  ];

  const navigationHandler = React.useCallback(
    ({ target }: React.ChangeEvent<HTMLSelectElement>) => navigate(target.value),
    [],
  );

  return (
    <div className='max-w-7xl px-4 pt-8 pb-10 mx-auto settings'>
      <Breadcrumbs
        paths={[
          { text: t('My Account'), href: '/profile' },
          { text: t('Settings'), href: '/settings' },
        ]}
      />

      <div className='mt-6 w-full flex flex-col lg:flex-row bg-white dark:bg-[#242424] rounded-xl sm:rounded-3xl shadow-sm p-4 sm:p-8'>
        <div
          className='flex justify-between lg:justify-start lg:flex-col basis-1/5 w-full lg:w-1/5 lg:border-r gap-y-4
        border-b lg:border-b-0 pb-2 mb-6 lg:mr-8
        '
        >
          <h2 className='text-xl leading-7 font-bold text-gray-900 dark:text-white lg:px-4'>
            {t('Settings')}
          </h2>
          <nav className='hidden lg:block mr-8'>
            <ul className='flex flex-col gap-y-2'>
              {navigation.map((i) => (
                <li key={i.to} className='block'>
                  <NavLink
                    to={i.to}
                    end
                    className={({ isActive }) =>
                      cls(
                        'block px-4 py-3 text-sm leading-5 font-medium text-blue-500 dark:text-[#FFDA68] rounded-md',
                        {
                          'bg-blue-50 dark:bg-[#FFDA68]/20': isActive,
                        },
                      )
                    }
                  >
                    {i.text}
                  </NavLink>
                </li>
              ))}
              <li className='block px-4 py-3 text-sm leading-5 font-medium text-blue-500 dark:text-[#FFDA68] rounded-md transition-all cursor-pointer'>
                <Link to='/logout'>
                  <i className='icon-logout -ml-0.5' /> {t('Log out')}
                </Link>
              </li>
            </ul>
          </nav>
          <select
            className='text-xs leading-4 font-normal border border-gray-200 rounded-lg lg:hidden'
            onChange={navigationHandler}
            defaultValue={navigation.find((i) => i.to === pathname)?.to}
          >
            {navigation.map((i) => (
              <option key={i.to} value={i.to}>
                {i.text}
              </option>
            ))}
          </select>
        </div>
        <div className='flex basis-4/5 w-full lg:w-4/5'>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

SettingsView.General = GeneralSettings;
SettingsView.Rewards = Rewards;
SettingsView.Activities = RecentActivities;
SettingsView.Connections = Connections;
SettingsView.Profile = EditProfile;
